import { render, staticRenderFns } from "./ExplainSection.vue?vue&type=template&id=6d0082a9&"
import script from "./ExplainSection.vue?vue&type=script&lang=js&"
export * from "./ExplainSection.vue?vue&type=script&lang=js&"
import style0 from "./ExplainSection.vue?vue&type=style&index=0&id=6d0082a9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports